//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../../media/MediaQuery";

//css
import styled from "styled-components";
// component
import MyPageProduct from "../../../../component/content/MyPageProduct";
import Pagination from "../../../../component/pagination/Pagination";
import BasicBtn from "../../../../component/button/BasicBtn";
import DefaultPop from "../../../../component/popup/DefaultModal";

// responsive
import { M, T } from "../../../../utils/MT";

export default function MyGrade(props) {
    // 등급 타이틀 리스트
    const gradeTitleList = ["회원단계", "최근 6개월간 구매 횟수", "구매 금액", "등급할인혜택"];
    // 등급 내용
    const [gradeData, setGradeData] = useState([]);

    useEffect(() => {
        const gradeList = [
            {
                id: 0,
                level: "Lv 1",
                num: "회원 혜택입니다.",
                price: "구매금액 입니다",
                benefit: "할인혜택 할인율입니다.",
            },
            {
                id: 1,
                level: "Lv 2",
                num: "회원 혜택입니다.",
                price: "구매금액 입니다",
                benefit: "할인혜택 할인율입니다.",
            },
            {
                id: 2,
                level: "Lv 3",
                num: "회원 혜택입니다.",
                price: "구매금액 입니다",
                benefit: "할인혜택 할인율입니다.",
            },
            {
                id: 3,
                level: "Lv 4",
                num: "회원 혜택입니다.",
                price: "구매금액 입니다",
                benefit: "할인혜택 할인율입니다.",
            },
            {
                id: 4,
                level: "Lv 5",
                num: "회원 혜택입니다.",
                price: "구매금액 입니다",
                benefit: "할인혜택 할인율입니다.",
            },
        ];
        setGradeData(gradeList);
    }, []);

    return (
        <Wrap>
            <MyGradeSection>
                {/* 회원등급 */}
                <MyGradeTitle>회원등급</MyGradeTitle>

                <MyGradeContent>
                    <MyGradeSubtext>회원혜택</MyGradeSubtext>

                    <MyGradeNotice>- 향후 맴버쉽 단계별 혜택 및 선정기준은 사전 통지 후 변경될 수 있습니다.</MyGradeNotice>
                    <MyGradeNotice>- 향후 맴버쉽 단계별 혜택 및 선정기준은 사전 통지 후 변경될 수 있습니다.</MyGradeNotice>
                </MyGradeContent>

                <PC>
                    <MyGradeTableWrap>
                        <MyGradeTable>
                            {gradeTitleList.map((item, index) => {
                                return <MyGradeListTitle key={index}>{item}</MyGradeListTitle>;
                            })}
                        </MyGradeTable>
                        {gradeData.map((current) => {
                            return (
                                <MyGradeTableList key={current.id}>
                                    <MyGradeListTitle>{current.level}</MyGradeListTitle>
                                    <MyGradeListTitle>{current.num}</MyGradeListTitle>
                                    <MyGradeListTitle>{current.price}</MyGradeListTitle>
                                    <MyGradeListTitle>{current.benefit}</MyGradeListTitle>
                                </MyGradeTableList>
                            );
                        })}
                    </MyGradeTableWrap>
                </PC>

                <Mobile>
                    {gradeData.map((current) => {
                        return (
                            <MbGradeTableWrap key={current.id}>
                                <MyGradeTable>
                                    {gradeTitleList.map((item, index) => {
                                        return <MyGradeListTitle key={index}>{item}</MyGradeListTitle>;
                                    })}
                                </MyGradeTable>

                                <MyGradeTableList>
                                    <MyGradeListTitle>{current.level}</MyGradeListTitle>
                                    <MyGradeListTitle>{current.num}</MyGradeListTitle>
                                    <MyGradeListTitle>{current.price}</MyGradeListTitle>
                                    <MyGradeListTitle>{current.benefit}</MyGradeListTitle>
                                </MyGradeTableList>
                            </MbGradeTableWrap>
                        );
                    })}
                </Mobile>

                {/* 페이징 */}
                <Paging>
                    <Pagination />
                </Paging>
            </MyGradeSection>
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto;
    }
`;
const MyGradeSection = styled.div``;
const MyGradeTitle = styled.h2`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;
const MyGradeContent = styled.div`
    margin-top: calc(100vw * (20 / 1920));

    border-top: 1px solid #222;

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin: ${M(20)} 0;
    }
`;
const MyGradeSubtext = styled.p`
    margin: calc(100vw * (20 / 1920)) 0 calc(100vw * (10 / 1920));

    font-size: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        margin: calc(100vw * (20 / 1300)) 0 calc(100vw * (10 / 1300));
        font-size: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin: ${M(20)} 0 ${M(10)};
        font-size: ${M(16)};
    }
`;
const MyGradeNotice = styled.p`
    font-family: "Noto-R";
    line-height: 1.5;

    font-size: calc(100vw * (16 / 1920));
    color: #aaaaaa;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (16 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;
const MyGradeTableWrap = styled.div`
    margin-top: calc(100vw * (30 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (30 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(30)};
    }
`;
const MyGradeTable = styled.ul`
    display: flex;

    padding: calc(100vw * (20 / 1920)) 0;

    background: #fafafa;
    border-bottom: 1px solid #dddddd;

    & li:nth-child(1) {
        width: calc(100vw * (115 / 1920));
    }
    & li:nth-child(2) {
        width: calc(100vw * (415 / 1920));
    }
    & li:nth-child(3) {
        width: calc(100vw * (115 / 1920));
    }
    & li:nth-child(4) {
        width: calc(100vw * (200 / 1920));
    }

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;

        & li:nth-child(1) {
            width: calc(100vw * (115 / 1300));
        }
        & li:nth-child(2) {
            width: calc(100vw * (415 / 1300));
        }
        & li:nth-child(3) {
            width: calc(100vw * (115 / 1300));
        }
        & li:nth-child(4) {
            width: calc(100vw * (200 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;
        padding: ${M(20)} 0;
        background: #fff;

        & li:nth-child(1) {
            width: ${M(190)};
        }
        & li:nth-child(2) {
            width: ${M(190)};
        }
        & li:nth-child(3) {
            width: ${M(190)};
        }
        & li:nth-child(4) {
            width: ${M(190)};
        }
    }
`;
const MyGradeListTitle = styled.li`
    text-align: center;

    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        text-align: left;
        font-size: ${M(15)};

        &:not(:last-child) {
            margin-bottom: ${M(15)};
        }
    }
`;
const MyGradeTableList = styled(MyGradeTable)`
    background: #fff;

    & li {
        font-family: "Noto-R";
    }
    & li:nth-child(1) {
        font-family: "Noto-B";
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;
    }
`;

const Paging = styled.div`
    margin-top: calc(100vw * (60 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (60 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(60)};
    }
`;

const MbGradeTableWrap = styled.div`
    display: flex;
`;
